module.exports = __webpack_public_path__ + "static/media/locationMarker.c7143d28.svg";